<template>
  <div class="my-prize">
    <img class="bg" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/new-draw-bg1.png" alt="">
    <div style="zIndex:1000;" class="return-home" @click="handleBack" v-show="!infoDialogVisible">
      <img class="return" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/1.png" alt="">
      <span>返回</span>
    </div>
    <div style="zIndex:1000;" class="return-home prize" @click="infoDialogVisible = false" v-show="infoDialogVisible">
      <img class="return" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/1.png" alt="">
      <span>关闭</span>
    </div>
    <img class="my-heard" v-show="!infoDialogVisible" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/2.png" alt="">
    <img class="my-heard" v-show="infoDialogVisible" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/7.png" alt="">
    <div class="content" id="contentList" :style="!infoDialogVisible ?  'overflowY: auto;' : 'overflowY: hidden'">
      <div class="award-list" v-show="!infoDialogVisible">
        <div class="item" v-for="item in awardList" :key="item.id">
          <div class="items">
            <img class="cover" :src="item.cover"/>
            <div class="info-wrap">
              <p class="name">{{ item.name }}</p>
              <div class="mid">
                <p class="date">有效期：{{ item.date }}</p>
              </div>
            </div>
          </div>
          <div class="btn" @click="openInfoDialog(item)" v-show="!item.code&&!item.outDate">
            <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/3.png" alt="">
          </div>
          <p class="status" v-show="item.outDate">已过期</p>
          <p class="code" v-show="item.code&&!item.outDate">
            <span>兑换码：{{ item.code }} </span>
            <img @click="storeDialogVisible=true" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/4.png" alt="">
          </p>
        </div>
      </div>
      <div class="info-dialog" v-show="infoDialogVisible">
        <div class="items">
          <img class="cover" :src="infoDialogData.cover"/>
          <div class="info-wrap">
            <p class="name">{{ infoDialogData.award_name }}</p>
            <div class="mid">
              <p class="date">有效期：{{ infoDialogData.date }}</p>
            </div>
          </div>
        </div>
        <div class="award-recipient-info">
          <p class="title">
            请填写领取奖品信息
            <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/5.png" alt="">
          </p>
          <div class="from">
            <div class="from-item">
              <p class="label"><span>*</span>姓名:</p>
              <input placeholder="请输入中奖人姓名" v-model="infoDialogData.name" max="64"/>
            </div>
            <div class="from-item">
              <p class="label"><span>*</span>手机号:</p>
              <input placeholder="请输入手机号" v-model="infoDialogData.tel" type="tel"/>
            </div>
            <div class="from-item">
              <p class="label"><span>*</span>所在地区:</p>
              <div class="address-wrap">
                <select
                  v-model="infoDialogData.province_id"
                  placeholder="选择省"
                  @input="handleProvinceChange"
                >
                  <option style="display:none" value="" disabled>请选择</option>
                  <option
                    v-for="item in addressData.provinceList"
                    :key="item.address_id"
                    :value="item.address_id"
                    :label="item.name"
                  >{{ item.name }}</option>
                </select>
                <select
                  v-model="infoDialogData.city_id"
                  placeholder="选择市"
                  @input="handleCityChange"
                >
                  <option style="display:none" value="" disabled>请选择</option>
                  <option
                    v-for="item in addressData.cityList"
                    :key="item.address_id"
                    :value="item.address_id"
                  >{{ item.name }}</option>
                </select>
                <select
                  v-model="infoDialogData.area_id"
                  placeholder="选择区"
                >
                  <option style="display:none" value="" disabled>请选择</option>
                  <option
                    v-for="item in addressData.districtList"
                    :key="item.address_id"
                    :value="item.address_id"
                    :label="item.name"
                  >{{ item.name }}</option>
                </select>
              </div>
            </div>
            <div class="bom-btn">
              <img @click="handleSubmit" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/my/6.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-show="awardList.length===0">
        <img src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/no-data.png">
      </div>
    </div>
    <!-- 兑换门店弹窗 -->
    <div class="store-dialog" v-if="storeDialogVisible">
      <store-dialog @close="storeDialogVisible=false"></store-dialog>
    </div>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/common";
import storeDialog from "./store.vue";
export default {
  components:{
    storeDialog
  },
  data(){
    return {
      awardList:[],
      infoDialogVisible: false,
      infoDialogData: {
        winning_record_id: '',
        cover:'',
        award_name:'',
        date:'',
        name:'',
        tel:'',
        province_id:'',
        city_id:'',
        area_id:''
      },
      addressData:{
        provinceList:[],
        cityList:[],
        districtList:[]
      },
      storeDialogVisible: false
    }
  },
  created(){
    this.getList();
  },
  methods:{
    getList(){
      let query = this.$route.query;
      let aid = query.aid;
      if(!aid){
        return false;
      }
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/lottery/winning_record/list?activity_id=${aid}&page=1&page_size=50`,
        method: "get",
      }).then((res) => {
        if(res.data.error_code===0){
          this.awardList = res.data.data.list.map((item)=>{
            return {
              id:item.winning_record_id,
              cover:item.prize_cover_image_url,
              name:item.prize_title,
              date:dateFormat("YYYY-mm-dd HH:MM", new Date(item.expire_time * 1000)),
              code:item.redemption_code,
              outDate: item.is_expire===1,
            };
          });
        }
      });
    },
    openInfoDialog(data){
      this.infoDialogData = {
        winning_record_id:data.id,
        cover:data.cover,
        award_name:data.name,
        date:data.date,
        name:'',
        tel:'',
        province_id:'',
        city_id:'',
        area_id:''
      };
      document.getElementById("contentList").scrollTop = 0;
      this.infoDialogVisible = true;
      this.getAddressData(0).then((res)=>{
        this.addressData.provinceList = res.data.data.list;
      });
    },
    hideInfoDialog(){
      this.infoDialogVisible = false;
    },
    getAddressData(id){
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      return this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v1/addresses?pid=${id}`,
        method: "get",
      });
    },
    handleProvinceChange(e) {
      this.getAddressData(e.srcElement.value).then((res) => {
        this.addressData.cityList = res.data.data.list;
        this.infoDialogData.city_id = "";
        this.addressData.districtList = [];
        this.infoDialogData.area_id = "";
      });
    },
    handleCityChange(e) {
      this.getAddressData(e.srcElement.value).then((res) => {
        this.addressData.districtList = res.data.data.list;
        this.infoDialogData.area_id = "";
      });
    },
    handleSubmit(){
      if(!this.infoDialogData.name){
        this.$toast('请填写姓名');
        return false;
      }
      if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(String(this.infoDialogData.tel)))){
        this.$toast('请填写正确的手机号');
        return false;
      }
      if(!this.infoDialogData.province_id){
        this.$toast('请填写省');
        return false;
      }
      if(!this.infoDialogData.city_id){
        this.$toast('请填写市');
        return false;
      }
      if(!this.infoDialogData.area_id){
        this.$toast('请填写区');
        return false;
      }
      let tokenCache = localStorage.getItem('mobile_musicwow_app_wx_token');
      this.$ajax({
        headers: {
          "X-DEVICE-TYPE": "4",
          "X-APP-NAME": "musicwow",
          "Content-Type": "application/json",
          "YW-TOKEN":tokenCache
        },
        url: process.env.VUE_APP_CONT_API + `api/v2/lottery/winning_record/exchange`,
        method: "post",
        params:{
          winning_record_id:this.infoDialogData.winning_record_id,
          username:this.infoDialogData.name,
          area_code:'86',
          mobile:this.infoDialogData.tel,
          province_id:this.infoDialogData.province_id,
          city_id:this.infoDialogData.city_id,
          area_id:this.infoDialogData.area_id,
          address:'',
        }
      }).then((res)=>{
        if(res.data.error_code===0){
          this.$toast('提交成功');
          this.infoDialogVisible = false;
        }
        this.getList();
      });
    },
    handleBack(){
      this.$emit('close');
    }
  }
}
</script>
<style lang="scss" scoped>
.my-prize {
  position: relative;
  height: 100vh;
  overflow: hidden;
  .bg {
    height: 100vh;
  }
  .return-home {
    z-index: 100;
    position: absolute;
    right: 16px;
    top: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #fff;
    .return {
      width: 40px;
      height: 40px;
      margin-right: 7px;
    }
  }
  .prize {}
  .my-heard {
    position: absolute;
    top: 25px;
    left: 45px;
    width: 289px;
    height: 137px;
    z-index: 100;
  }
  .content {
    position: absolute;
    top: 113px;
    left: 0;
    right: 0;
    bottom: 24px;
    width: 340px;
    margin:0 auto;
    border: 2px solid rgba(255, 255, 255, 1);
    border-radius: 30px;
    background: rgba(78, 0, 0, 0.55);
    box-sizing: border-box;
    .award-list{
      padding: 50px 23px 0 23px;
      .item{
        text-align: left;
        border-bottom: 1.1px dashed rgba(255, 255, 255, 1);
        margin-top: 15px;
        .items {
          display: flex;
          .cover{
            width: 90px;
            height: 90px;
            border-radius: 16px;
            margin-right: 15px;
          }
          .info-wrap{
            flex: 1;
            .name{
              color: rgba(255, 255, 255, 1);
              font-size: 16px;
              width: 188px;
              margin-bottom: 10px;
            }
            .mid{
              .date{
                font-size: 12px;
                color: rgba(255, 255, 255, 0.5);
              }
            }
          }
        }
        .btn{
          width: 116px;
          height: 43px;
          margin: 15px 0 15px auto;
          img {
            height: 43px;
          }
        }
        .status{
          margin-top: 10px;
          font-size: 16px;
          text-align: right;
          color: rgba(248, 91, 86, 1);
          margin-bottom: 15px;
        }
        .code{
          margin: 15px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 293px;
          height: 43px;
          overflow: hidden;
          border-radius: 21.5px;
          background: rgba(255, 243, 80, 0.17);
          span {
            font-size: 16px;
            color: rgba(255, 223, 0, 1);
            margin-left: 31px;
          }
          img {
            width: 116px;
            height: 43px;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .info-dialog{
    height: 100%;
    overflow: hidden auto;
    z-index: 1000;
    margin:0 8px;
    .items {
      display: flex;
      margin:55px 15px 0 15px;
      .cover{
        width: 90px;
        height: 90px;
        border-radius: 16px;
        margin-right: 15px;
      }
      .info-wrap{
        flex: 1;
        text-align: left;
        .name{
          color: rgba(255, 255, 255, 1);
          font-size: 16px;
          width: 188px;
          margin-bottom: 10px;
        }
        .mid{
          .date{
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
    .award-recipient-info {
      margin: 26px 0 8px 0;
      height: 360px;
      border-radius: 30.5px 30.5px 20px 20px;
      background: rgba(124, 17, 2, 1);
      overflow: hidden;
      .title {   
        display: flex;
        height: 60px;
        border-radius: 30.5px;
        background: rgba(171, 69, 28, 1);
        color: rgba(255, 223, 0, 1);
        font-size: 18px;
        align-items: center;
        justify-content: center;
        padding-left: 10px;
        img {
          width: 60px;
          height: 60px;
        }
      }
      .from {
        padding: 37px 25px;
        .from-item {
          display: flex;
          height: 36px;
          margin-bottom: 18px;
          .label {
            line-height: 36px;
            width: 80px;
            color: rgba(255, 255, 255, 1);
            font-size: 13px;
            text-align: left;
            span {
              color: rgba(248, 91, 86, 1);
              margin-right: 3px;
            }
          }
          input {
            flex: 1;
            font-size: 13px;
            width: 190px;
            height: 36px;
            border-radius: 18px;
            background: rgba(216, 216, 216, 0.2);
            border: 0;
            color: rgba(255, 255, 255, 1);
            padding-left: 17px;
            box-sizing: border-box;
          }
          .address-wrap {
            flex: 1;
            display: flex;
            border-radius: 18px;
            background: rgba(216, 216, 216, 0.2);
            overflow: hidden;
            padding-left: 12px;
            select{
              width: 60px;
              font-size: 12px;
              background: none;
              border: 0;
              color: #fff;
              position: relative;
              option{
                color: #333;
              }
            }
          }
        }
        .bom-btn {
          margin-top: 38px;
        }
      }
    }
  }
}
.no-data{
  padding-top: 120px;
  img{
    width: 144px;
    height: auto;
  }
}
.store-dialog{
  position: fixed;
  height: 100vh;
  width: 100vw;
  top:0;
  left:0;
  overflow: hidden;
  z-index: 10100;
}
</style>